import React, { Component } from 'react';
import { Trans } from "react-i18next";
import { NavLink } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import Swiper from 'react-id-swiper';
import axios, { post } from 'axios';
import Cookies from 'universal-cookie';
import Loader from 'react-loader-spinner';
import "../../config/i18n";
import { withTranslation } from "react-i18next";
import ls from "local-storage"; 
import { options } from "../../config/options";
import * as ReactDom from 'react-dom'; 


class BannerList extends Component { 
    constructor(props) {
        super(props);
        this.loggedIn = sessionStorage.getItem('loggedin');
        this.msgFilter = this.msgFilter.bind(this);
        this.homeLink = this.homeLink.bind(this);
        this.state = {
           
            file: require("../../assets/img/cap1.png"),
            modal22:false,
            backdrop: true,
            api_url:localStorage.getItem('api_url'),            
            lang: ls.get('LangKeySet') || options[0],
            langKey: ls.get('LangValue'),
            user_id:JSON.parse(localStorage.getItem('session_userid')),
            bannerlist: [],
            currency:'',
            loadmore:'none'

        }
        
    }
      
    componentDidMount(){

        //order id
        const search = window.location.search;
        const params = new URLSearchParams(search);
        let payment_session_id = params.get('orderId');
        if(payment_session_id) {       
            let data = new FormData();
            data.append('user_id', JSON.parse(localStorage.getItem('session_userid')));  
            data.append('language', this.state.langKey); 
            data.append('order_id', payment_session_id); 
            
            axios({
                method: 'post',
                url: this.state.api_url+'cibresponse',
                data: data, 
                config: { headers: {'Content-Type': 'multipart/form-data' }}
            }).then(res => {
              console.log("fffffff");
                console.log(res);
              

              if(res.data.status === "false") { 
                console.log("ddddddd");
                console.log(res.data);
                // this.setState({
                //     alert_msg: res.data.message,
                //     suc_msg: 'successMsg floatingAlerts1',
                // });

                this.setState({
                  modal22: true,
                  backdrop: false,
                  message: res.data.message
               })
    
                // setTimeout(() => {
                //     this.setState({
                //         suc_msg: 'successMsghide',
                //         isAlertShown: true
                //     });
                // }, 5000);
              }else{console.log("ddddddd===============");

              }
            });
        }
        //order id

        this.setState({
            loader:'loder-icon'
            });
            setTimeout(() => {
                this.setState({
                    profilespace: '',
                    loader: 'none'
                });
              }, 300);

        var datalist = new FormData();   
          datalist.set('user_id', JSON.parse(localStorage.getItem('session_userid'))); 
          datalist.set('language', this.state.langKey); 
          
          axios({
            method: 'post',
            url: this.state.api_url+'webprofile',
            data: datalist,    
            config: { headers: {'Content-Type': 'multipart/form-data' }}
              }).then(res => {

                if(res.data.status === 'true') {
                    this.setState({
                        currency: res.data.result.currency,
                        bannerperprice:res.data.result.bannerprice
                    });
                } else {
                    this.props.history.push("/login");   
                }


            });
       
        axios.get(this.state.api_url+`admindatas`)
        .then(res => {
           
            const datas = res.data.result;           
            const country_raw = res.data.result.country;
            var country = [];
            country_raw && country_raw.map((i,k)=>{
                // console.log('k ~ '+i.id);
                var country_each_index = {};
                country_each_index.value = i.id;
                country_each_index.label = i.name+' - '+i.currencycode;
                country.push(country_each_index);
            })
            
            this.setState({
                country,
                bannerdays:res.data.result.bannerdays,
                });

        })

         var datalist = new FormData();   
         datalist.set('user_id', JSON.parse(localStorage.getItem('session_userid'))); 
         datalist.set('id', 1); 
         datalist.set('language', this.state.langKey); 
         
          
          axios({
            method: 'post',
            url: this.state.api_url+'bannerlistweb',
            data: datalist,    
            config: { headers: {'Content-Type': 'multipart/form-data' }}
              }).then(res => {
                const data = res.data;
                //console.log(data);

                if(res.data.status === 'true') {
                    //alert(res.data.status);
                    this.setState({
                        bannerlist: data.banner,
                    });
                } else {
                     this.setState({
                        bannerlist: '',
                    });
                }


            });       
    
      }

      msgFilter(e){
            //alert(e.target.value);
            if(e.target.value == 0){

                this.props.history.push("/app/Banner");   
            }
            else if(e.target.value == 1){
                this.props.history.push("/app/BannerAdd");   
            }

        }

        homeLink() {
          this.setState({
              modal22: false,
             
  
          })
          this.props.history.push("/app/Banner");
      }

     msgFilter(e){
            //alert(e.target.value);
            if(e.target.value == 0){

                this.props.history.push("/app/Banner");   
            }
            else if(e.target.value == 1){
                this.props.history.push("/app/BannerAdd");   
            }

        }
      

    render() {
      const { t } = this.props; 
  var style = {
            zIndex:10,
            backgroundColor:"white",
            position:"absolute",
            height:"80vh",
            width:"100%",
            display:"flex",
            justifyContent:"center",
            alignItems:"center",
            //width:"100%",
            overflowY:"hidden"
          };

        

        return (

          
        
      <div className="rightSideContent">
         <Modal isOpen={this.state.modal22} toggle={this.homeLink} className="premiumPopup vertically-center apd5">
                        <ModalHeader toggle={this.homeLink}><h4 class="modal-title" style={{ 'marginTop': "10px" }}><Trans i18nKey={this.state.message}>{this.state.message}</Trans></h4></ModalHeader>
                        <ModalBody>
                            <div className="modal-body">
                            <div class="justify-content-center">
                            <h5><Trans i18nKey={"In the event of a payment problem, please contact the SATIM toll-free number 3020."}>In the event of a payment problem, please contact the SATIM toll-free number 3020.</Trans></h5>

                                    </div>
                                <div class="d-flex justify-content-end">
                                    <div class="mr-3"><button class="border-0 bg-white pink-color" onClick={this.homeLink}><Trans i18nKey="Ok">Ok</Trans></button></div>
                                </div>
                            </div>
                        </ModalBody>
                    </Modal>
        <div className="setting-page addsBanner">
          <div className="d-flex profile-header-top stickyProfileHead justify-content-between apd15 apr0 apl0 white-bg">
            <div className="heading-left-top d-flex">
              <div className="align-self-center">
                <div className="iconHolder align-self-center mr-1">
                  <div className="backGlow d-block d-lg-none">
                    <div className="sideBarToggler sidebarIcoPos" />
                  </div>
                </div>
              </div>
              <select name="" id="bannerdrop"  onChange={this.msgFilter} className="px-2 arrow-center align-self-center ml-1 bold-font border-0 topHeaderDrops">
                            <option value="0">{t("Banner Advertise history")}</option>   
                            <option value="1">{t("Add Banner")}</option>
                            
                        </select>
            </div>
            <div className="backGlow white-bg" />
             
          </div>
          <div className={this.state.loader}>
                        <div style={style} id="loader">
                            <Loader type="Bars" color="#ca2a1e" height={30} width={50} />
                        </div>
                    </div>
          <div className="links">
            <NavLink to={"/app/Banner"} > <p className="redcolor"><Trans i18nKey="Pending">Pending</Trans></p></NavLink>
            <NavLink to={"/app/BannerExpired"} > <p ><Trans i18nKey="Expired">Expired</Trans></p></NavLink>
          </div>
          <div className="boxParent">
            <div className="setFiltBox">
             { this.state.bannerlist ? 

                this.state.bannerlist.map(((banner,index) =>
                 
              <div className="mb-4">
                <div className="d-flex justify-content-between align-items-center flex-wrap banneramount">
                  <div>

                    <div className="text-truncate BtoRcolor">
                      <NavLink to={`/app/Banner/BannerView/${banner.banner_id}`}>
                       {banner.startdate} {"-"} {banner.enddate}
                       </NavLink>
                    </div>
                    <div className="text-truncate bold-font redcolor">
                       {banner.totalCost} {banner.currency}
                    </div>
                  </div>


                  <div className="text-right">
                  {banner.status == 0 ?
                    <div className="tag paid"><span><Trans i18nKey="Pending">Pending</Trans></span></div>
                    :
                    banner.paidstatus == 1 ?
                    <div className="tag unPaid"><span><Trans i18nKey="Paid">Paid</Trans></span></div>
                    :
                    banner.status == 1 ?
                    <div className="tag unPaid"><span><Trans i18nKey="Accepted">Accepted</Trans></span></div>
                    :
                    banner.status == 3 ?
                    <div className="tag expired"><span><Trans i18nKey="Expired">Expired</Trans></span></div>
                    :
                    <div className="tag expired"><span><Trans i18nKey="Rejected">Rejected</Trans></span></div>
                }
                    <div className="custom_font"><Trans i18nKey="Posted on">Posted on</Trans> - {banner.createdDate}</div>
                    
                    
                  </div>
                </div>
              </div>     
              ))
             : 
              <div id='bannermsg'><Trans i18nKey="No Data Found!!">No Data Found!!</Trans></div>
            }
              
             
            </div>
          </div>
        </div>
      </div>
      
        
            
        ) 
    }
}

export default withTranslation("translations")(BannerList);
